export default __webpack_public_path__ + "static/media/linux_logo.404648ac.png";